import type { z } from 'zod'
import type { billSchema } from '@super-mega/server/contracts/bill'
import { isBillWithoutReceivableBalance } from './bill-group.ts'

type Bill = z.infer<typeof billSchema>
export type BillSelectionMode = 'group' | 'money' | 'refund'

export function billSelectionError(bills: Bill[], mode: BillSelectionMode) {
  if (!bills.length) return '请先选择账单'
  const first = bills[0]
  if (bills.some((bill) => bill.organizationId !== first.organizationId)) {
    return '所选账单的经营主体不同，请重新选择'
  }
  if (bills.some((bill) => bill.customerId !== first.customerId || bill.payeeId !== first.payeeId)) {
    return '所选账单的客户或付款对象不同，请重新选择'
  }
  if (bills.some((bill) => bill.direction !== first.direction)) {
    return '应收和应付账单不能一起登记，请分别选择'
  }
  if (mode === 'group' && (first.direction !== 'receivable' || first.customerId === null)) {
    return '收款账单组只能选择有客户的应收账单'
  }
  const voided = bills.filter((bill) => bill.status === 'voided')
  if (voided.length) return `已作废账单不能操作：${voided.map((bill) => bill.billNo).join('、')}`
  const unknown = bills.filter((bill) => bill.totalAmount === null)
  if (unknown.length) {
    return `以下账单金额尚未核定，请先在账单详情中核定金额：${unknown.map((bill) => bill.billNo).join('、')}`
  }
  if (mode === 'group') {
    const settled = bills.filter(isBillWithoutReceivableBalance)
    if (settled.length) {
      return `以下账单已无待收余额，请移除后继续：${settled.map((bill) => bill.billNo).join('、')}`
    }
  }
  return null
}
